import React from 'react';
import NwHomeLayout from 'components/Layout/NwHomeLayout';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { light } from '@fortawesome/fontawesome-svg-core/import.macro';
import { Button } from 'antd';
import { Link } from 'react-router-dom/cjs/react-router-dom.min';
import { ErrorWrapper } from './ErrorsUI';



const ExpiredPackage = () => {
    return (
        <NwHomeLayout>
            <ErrorWrapper>
                <div className="error-wrapper">
                    <h1>Error</h1>
                    <div className="error-content">
                        <div className="error-icon">
                            <FontAwesomeIcon icon={light("calendar-xmark")} />
                        </div>
                        <div className="error-message">This Package Has Expired</div>
                    </div>
                    <div className="error-home-link">
                        <Link to="/">
                            <Button className="code-button" size="large" type="primary">click here to type another code</Button>
                        </Link>
                    </div>
                </div>
            </ErrorWrapper>
        </NwHomeLayout>
    )
};

export default ExpiredPackage;
